// removed by extract-text-webpack-plugin
module.exports = {"page-title":"src-components-PageTitle----index-module---page-title---3WFKp","divider":"src-components-PageTitle----index-module---divider---zkSFg"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PageTitle/index.module.css
// module id = 428
// module chunks = 168707334958949